import { Link } from 'react-router';
import { BackButton } from '../shared/navigation/BackButton';

/**
 * Sin `aria-labelledby`: una `<section>` sola en la página, sin otra de su
 * tipo con la que pueda confundirse, no necesita nombre de región. Ponérselo
 * igual hace que el lector anuncie el título dos veces: una como nombre de la
 * región al entrar, otra al llegar al propio `<h1>` (rules/accesibilidad.md).
 */
export function NotFound() {
  return (
    <section className="state-panel">
      <p className="eyebrow">Camino sin salida</p>
      <h1>Aquí no hay nada</h1>
      <p>
        Este camino no lleva a ningún sitio. Puede que el enlace esté incompleto, o que la página
        haya cambiado de lugar desde que lo guardaste.
      </p>
      <p className="state-panel-actions">
        <BackButton />
        <Link className="btn btn-accent" to="/">Volver a la página de inicio</Link>
      </p>
    </section>
  );
}
